import "./Header.css"
import { useState, useEffect } from "react"
import _ from "lodash"
function Header({ onData }) {
    const [partTops, setPartTops] = useState({})
    useEffect(() => {
      // 页面加载，获取每个锚点的高度
      setTimeout(() => {
        
        let homeNode = document.getElementById('home-1').scrollHeight
        let aboutNode = document.getElementById('about-2').scrollHeight
        let productionNode = document.getElementById('production-3').scrollHeight
        let contactNode = document.getElementById('contact-4').scrollHeight

        let allTops = {
          homeTop:document.getElementById('home-1').offsetTop,  // 151
          homeHeight:homeNode,
          aboutTop:document.getElementById('about-2').offsetTop,  // 1094
          aboutHeight:aboutNode,
          productionTop:document.getElementById('production-3').offsetTop,  //  
          productionHeight:productionNode,
          contactTop:document.getElementById('contact-4').offsetTop,
          contactHeight:contactNode,
        }
  
        setPartTops(allTops)
      }, 500);
      
      
      
  },[])

    const menus = [
      { 
        name:'HOME',
        value:'home-1'
      },
      {
        name:'ABOUT US',
        value:'about-2'
      },
      {
        name:'PRODUCTS',
        value:'production-3'
      },
      {
        name:'CONTACT US',
        value:'contact-4'
      }
    ]

    const [menuIndex,SetMenuIndex] = useState(0)

    const changeMenu = (item,index) => {
      console.log(onData);
      
      onData(item.value)
      SetMenuIndex(index)
    }


    // logo图片
    const LOGO = require('../../../../assets/images/leyang-logo.png')


    // 监听页面滚动事件切换菜单
    window.addEventListener('scroll',_.debounce(() => {

      let windowScroll = window.scrollY
      
      if(windowScroll < (partTops.aboutTop - partTops.homeHeight/2)){
        SetMenuIndex(0)
      }else if(windowScroll >= (partTops.aboutTop - partTops.homeHeight/2) && windowScroll < (partTops.productionTop - partTops.aboutHeight/2)){
        SetMenuIndex(1)
      }else if(windowScroll >= (partTops.productionTop - partTops.aboutHeight/2) && windowScroll < (partTops.contactTop - 300)){
        SetMenuIndex(2)
      }else if(windowScroll >= (partTops.contactTop - 300)){
        SetMenuIndex(3)
      }
    },10))

    window.addEventListener('beforeunload', function(event) {
      // 处理页面刷新事件的逻辑
      window.scrollTo({
        top:0,
        // behavior:'smooth'
      })
      SetMenuIndex(0)
    })

    return (
      <div className="header">
        <div className="menu">
          <section>
          {/* <img alt="logo" src="logo.png" /> */}
            <section className="header-logo">
              <img alt="logo" src={ LOGO } />
              <span>Joy Fashion</span>
            </section>
          
            <div className="lines"></div>
            <div className="line-font">Professional Knitwear Manufactuer in China</div>
          </section>
          <div className="right">
            <ul>
              {
                menus.map((item,index) => {
                  return <li className={ index === menuIndex ? 'activeIndex' : '' } onClick={ ()=>changeMenu(item,index) } key={ item.name + item.value }>{ item.name }</li>
                })
              }
              {/* <li>切换english</li> */}
            </ul>
          </div>
        </div>
      </div>
    );
  }
  

  
  export default Header;